import React from 'react';

export function SubtaskIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      width="20"
      viewBox="0 0 20 20"
      fill="#a855f7"
    >
      <path d="M4 5h12v2H4zM4 9h12v2H4zM4 13h12v2H4z" />
    </svg>
  );
}
